import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Objective, ObjectiveProgress } from '../models/objective.model';
import { ApiProviderService } from './api-provider.service';

@Injectable({
  providedIn: 'root'
})
export class ObjectiveService {
  
  selectedObjective: Objective;
  private objectivesSubject = new BehaviorSubject<Objective[]>([]);
  objectives$ = this.objectivesSubject.asObservable();
  

  constructor(
    private apiProvider : ApiProviderService
  ) { }


  createObjective(objective: Objective): Observable<Objective> {
    return this.apiProvider.request<Objective>('POST', 'Objectives', objective);
  }

  getObjectiveById(objectiveId: number): Observable<Objective> {
    return this.apiProvider.request<Objective>('GET', `Objectives/${objectiveId}`);
  }

  updateObjective(objectiveId: number, updatedData: Partial<Objective>): Observable<Objective> {
    return this.apiProvider.request<Objective>('PUT', `Objectives/${objectiveId}`, updatedData);
  }

  deleteObjective(objectiveId: number): Observable<void> {
    return this.apiProvider.request<void>('DELETE', `Objectives/${objectiveId}`).pipe(
      tap(() => {
        const updatedObjectives = this.objectivesSubject.value.filter(obj => obj.id !== objectiveId);
        this.objectivesSubject.next(updatedObjectives); // Met à jour la liste sans requête supplémentaire
      })
    );  }

  addProgressUpdate(objectiveId: number, progress: ObjectiveProgress): Observable<ObjectiveProgress> {
    return this.apiProvider.request<ObjectiveProgress>('POST', `Objectives/${objectiveId}/progress`, progress);
  }

  getProgressUpdates(objectiveId: number): Observable<ObjectiveProgress[]> {
    return this.apiProvider.request<ObjectiveProgress[]>('GET', `Objectives/${objectiveId}/progress`);
  }

  getClientProgressSummary(clientId: string): Observable<any> {
    return this.apiProvider.request<any>('GET', `Objectives/client/${clientId}/summary`);
  }

  

  //fonction pour les objectifs Observables 

  getClientObjectives(clientId: string): void {
    this.apiProvider.request<Objective[]>('GET', `Objectives/client/${clientId}`)
      .subscribe(objectives => this.objectivesSubject.next(objectives));
  }
  
  addObjective(objective: Objective) {
    const currentObjectives = this.objectivesSubject.value; 
    this.objectivesSubject.next([...currentObjectives, objective]);
  }




}
